import { Container, Row } from "reactstrap";
import { FormWidgetsTitle, TouchSpinTitle } from "../../../../../constants";
import ButtonsWithPrefixPostfix from "./ButtonsWithPrefixPostfix";
import DefaultTouchSpin from "./DefaultTouchSpin";
import IconsWithPrefixAndPostfix from "./IconsWithPrefixAndPostfix";
import OutlinedTouchSpin from "./OutlinedTouchSpin";
import RoundedTouchSpin from "./RoundedTouchSpin";
import Breadcrumbs from "../../../../../coreComponents/breadcrumbs";

const TouchSpinContainer = () => {
  return (
    <>
      <Breadcrumbs mainTitle={TouchSpinTitle} parent={FormWidgetsTitle} />
      <Container fluid>
        <div className="bootstrap-touchspin">
          <Row>
            <DefaultTouchSpin />
            <OutlinedTouchSpin />
            <IconsWithPrefixAndPostfix />
            <ButtonsWithPrefixPostfix />
            <RoundedTouchSpin />
          </Row>
        </div>
      </Container>
    </>
  );
};
export default TouchSpinContainer;
